"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NEW_STUDIO_SETTINGS = exports.LOW_FIDELITY = exports.HIGH_FIDELITY = void 0;
var LOW_FIDELITY = exports.LOW_FIDELITY = {
  height: 180,
  width: 320,
  frameRate: 5,
  bitRate: 500
};
var HIGH_FIDELITY = exports.HIGH_FIDELITY = {
  height: 720,
  width: 1280,
  frameRate: 30,
  bitRate: 2500
};
var NEW_STUDIO_SETTINGS = exports.NEW_STUDIO_SETTINGS = {
  AUDIO_SAMPLERATE: '48000',
  AUDIO_BITRATE: '160000',
  SCREEN_HEIGHT: '720',
  SCREEN_WIDTH: '1280',
  VIDEO_BITRATE: '3000',
  VIDEO_BUFSIZE: '1500k',
  AUDIO_DELAY: '0',
  VIDEO_FRAMERATE: '30'
};